<template>
<div>
    <section v-if="organizedTournaments.length > 0">
        <h2>Als Veranstalter</h2>
        <router-link :to="`tournament/${t.id}`" v-for="t in organizedTournaments" :key="t.id" class="item">
            <img src="images/tournament-dark.png" class="tournament">
            <h3>
                {{ t.name }}
            </h3>
            <small>
                {{ t.status | tournament_status }}
            </small>
        </router-link>
    </section>

    <section v-if="invitations.length > 0">
        <h2>Als Teilnehmer</h2>
        <router-link :to="`tournament/${inv.tournament_id}`" v-for="inv in invitations" :key="inv.id" class="item">
            <img src="images/tournament-dark.png" class="tournament">
            <h3>
                {{ inv.tournament.name }}
            </h3>
            <small>
                {{ inv.tournament.status | tournament_status }}
            </small>
        </router-link>
    </section>

    <section class="activities" v-if="activities.length > 0">
        <h2>Aktivität</h2>
        <timeline :activities="activities" />
    </section>

    <section v-if="organizedTournaments.length == 0 && 
                   invitations.length == 0">
        <h2>Turniere</h2>
        <div class="no-results">
            Hier ist noch nichts los :(<br>
            Organisiere ein Turnier, um das zu ändern!
        </div>
    </section>
</div>
</template>

<script>
import _ from 'underscore'
import base from 'base.vue'
import timeline from 'components/timeline.vue'

export default {
    mixins: [ base ],
    components: { 'timeline': timeline },
    data () {
        return {
            rawInvitations: [],
            organizedTournaments: [],
            activities: []
        }
    },
    computed: {
        invitations () {
            var ids = _.pluck(this.organizedTournaments, 'id')

            return _.filter(this.rawInvitations, i => {
                return ids.indexOf(i.tournament_id) == -1
            })
        }
    },
    methods: {
        fetchData () {
            const that = this
            const requests = []

            return this.$api.get('tournaments')
            .then(response => {
                that.rawInvitations = response.data.invitations
                that.organizedTournaments = response.data.tournaments
                that.activities = response.data.timeline
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// tournaments.vue?940e1fa0